export enum DATA_TEST_ID {
  ERROR_PAGE = 'error-page',
  HEADER_BAR = 'header-bar',
  SUCCESS_PAGE = 'success-page',
  TAB_CONTENT = 'tab-content',
  /** Webform */
  WEBFORM = 'webform',
  WEBFORM_CONTAINER = 'webform-container',
  WEBFORM_SUBMIT_BUTTON = 'webform-submit-button',
  WEBFORM_CAPTCHA = 'webform-captcha',
  WEBFORM_ACCORDION = 'webform-accordion',
}
